/* 
This object is to help ProductImageSlider.js determine when to use a cross-browser image set from S3 
instead of the large 1080p images we have for course screenshots. Cross browser images are located here on S3: 
https://cdn-d.mindedgeonline.com/course-screenshots-cb/... 
*/

/** These arrays should be used for the actual course and suites ids and NOT the image folder numbers. */
export const screenshotProdList = {
    courses: [
        294, 305, 307, 346, 873, 895, 896, 1013, 1034, 1040, 1047, 1056, 1075, 1076,
        1112, 1488, 1547, 1558, 1566, 1577, 1579, 1582, 1587, 1596, 1609, 1628, 1635,
        1638, 1649, 1652, 1691, 1713, 1771, 1866, 1868, 1871, 1874, 1886, 1912,
        1913, 1933, 1975, 1979, 1985, 1919, 2037
    ],
    suites: [3153, 3159, 3164, 5833, 7843, 8778, 9441, 12727, 16190]
};